<template>
  <div class="wallet-connector-container">
    <div class="wallet-item wallet-item-bg-1">
      <div class="wallet-logo-box">
        <div class="img-logo-helper">
          <img src="/static/svg/wallet-metamask.svg">
        </div>
      </div>
      <div class="wallet-content-box">
        <div class="wallet-type-name">
          {{ $t('exchange.metamask') }}
        </div>
        <div class="wallet-type-desc">
          {{ $t('exchange.metamask_detail') }}
        </div>
        <div class="wallet-type-connect">
          <a
            v-if="currentWalletProvider === 'metamask'"
            class="wallet-type-connect-btn"
            data-test="wallet-connector--connect-metamask-button"
            @click="connectWithMetaMask()"
          >
            {{ $t('exchange.connect') }}
          </a>
          <a
            v-else
            class="wallet-type-connect-btn"
            href="https://metamask.io/"
            data-test="wallet-connector--install-metamask-button"
            target="_blank"
          >
            {{ $t('exchange.install_metamask') }}
          </a>
        </div>
      </div>
    </div>
    <div class="wallet-item wallet-item-bg-2">
      <div class="wallet-logo-box">
        <div class="img-logo-helper">
          <img src="/static/svg/wallet-connect.svg">
        </div>
      </div>
      <div class="wallet-content-box">
        <div class="wallet-type-name">
          {{ $t('exchange.wallet_connect') }}
        </div>
        <div class="wallet-type-desc">
          {{ $t('exchange.mobile_detail') }}
        </div>
        <div class="wallet-type-connect">
          <a
            class="wallet-type-connect-btn"
            @click="connectWithWalletConnect()"
          >
            {{ $t('exchange.connect') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * WalletConnector Component
 */

import Service from './service.js'
import { mapState } from 'vuex'
import { isCorrectNetwork, getCorrectNetwork } from '@/environments'
import { kulapApi } from '@/resources'
import Web3 from 'web3'
import Web3Modal from 'web3modal'
import WalletConnectProvider from '@walletconnect/web3-provider'

export default {
  name: 'WalletConnector',
  data () {
    return {
      service: null
    }
  },
  computed: {
    ...mapState({
      currentWalletProvider: state => state.currentWalletProvider,
      currentNetwork: state => state.currentNetwork
    })
  },
  created () {
    this.service = new Service({
      store: this.$store,
      kulapApi
    })
  },
  methods: {
    getTheCorrectNetwork () {
      const network = getCorrectNetwork()
      return network.charAt(0).toUpperCase() + network.slice(1)
    },
    async connectWithMetaMask () {
      if (this.currentNetwork !== 'disconnected' && !isCorrectNetwork(this.currentNetwork)) {
        const textCurNetwork = `${this.currentNetwork.charAt(0).toUpperCase()}${this.currentNetwork.slice(1)}`
        this.$buefy.toast.open({
          message: `${this.$t('messages.not_support')} <b>${textCurNetwork}</b>, ${this.$t('messages.wrong_eth_network', [this.getTheCorrectNetwork()])}`,
          type: 'is-danger',
          duration: 5000
        })
        return
      }
      // Modern dapp browsers, No authorize access
      if (typeof window.ethereum !== 'undefined') {
        window.ethereum.request({ method: 'eth_requestAccounts' })
        this.intervalFetchFirstAddress()
      // Not logged in
      } else {
        this.$dialog.alert({
          title: this.$t('messages.login_error'),
          message: this.$t('messages.not_login_metamask'),
          type: 'is-danger'
        })
      }
    },
    async intervalFetchFirstAddress () {
      const wallets = await this.service.getWallets()
      if (!wallets.length) {
        setTimeout(() => {
          this.intervalFetchFirstAddress()
        }, 1000)
      } else {
        if (!isCorrectNetwork(this.currentNetwork)) {
          this.isCorrectNetworK = false
        }
        await this.connectToNewWallet('metamask', this.service.web3, wallets)
        this.$buefy.toast.open({
          message: this.$t('messages.metamask_connected'),
          type: 'is-success'
        })
      }
    },
    getWalletConnectWeb3Modal () {
      console.log('getWalletConnectWeb3Modal')
      const providerOptions = {
        walletconnect: {
          package: WalletConnectProvider, // required
          options: {
            rpc: {
              1: process.env.ETH_NODE_URL,
              1337: process.env.ETH_NODE_URL
            }
          }
        }
      }

      const web3Modal = new Web3Modal({
        cacheProvider: false, // optional
        providerOptions, // required
        disableInjectedProvider: true
      })
      return web3Modal
    },
    async connectWithWalletConnect () {
      const web3Modal = this.getWalletConnectWeb3Modal()

      const provider = await web3Modal.connect()

      const web3 = new Web3(provider)
      const accounts = await web3.eth.getAccounts()
      await this.connectToNewWallet('wallet-connect', web3, accounts)
      this.$buefy.toast.open({
        message: this.$t('messages.wallet_connect_connected'),
        type: 'is-success'
      })
    },
    async connectToNewWallet (provider, web3, wallets) {
      console.log('connectToNewWallet', provider, wallets)
      this.$store.dispatch('setCurrentWalletProvider', provider)
      this.$store.dispatch('setCurrentWeb3', web3)
      if (wallets.length > 0) {
        let currentNetwork = await web3.eth.net.getNetworkType()
        if (process.env.ENV === 'alpha') {
          currentNetwork = 'main'
        }
        this.$store.dispatch('setCurrentNetwork', currentNetwork)
        if (isCorrectNetwork(currentNetwork)) {
          this.$store.dispatch('setWallets', wallets)
          this.$store.dispatch('setIsWalletConnected', true)
        }
      }
      return wallets
    }
  }
}
</script>

<style scoped lang="scss">
.wallet-connector-container {
  float: left;
  width: 100%;
}
.wallet-item {
  float: left;
  width: 100%;
  height: 230px;
  padding: 30px;
  box-shadow: 0 2px 4px 0 rgba(85, 85, 85, 0.5);
  margin-bottom: 30px;
  border-radius: 3px;
  display: flex;
  align-items: center;
}
.wallet-item-bg-1 {
  background-color: #3f5eab;
}
.wallet-item-bg-2 {
  background-color: #0559af;
}
.wallet-item-bg-3 {
  background-color: #2378b9;
}
.wallet-logo-box {
  float: left;
  width: 130px;
  height: 130px;
  background-color: #34495e;
  border-radius: 50%;
  text-align: center;
  margin-right: 30px;
}
.img-logo-helper {
  height: 100%;
  width: 100%;
  line-height: 130px;
}
.img-logo-helper img {
  vertical-align: middle;
}
.wallet-content-box {
  float: left;
  width: calc(100% - 130px - 30px);
}
.wallet-type-name {
  float: left;
  width: 100%;
  font-size: 26px;
  color: #fff;
}
.wallet-type-desc {
  float: left;
  width: 100%;
  font-size: 13px;
  color: #fff;
}
.wallet-type-connect {
  float: left;
  width: 100%;
  margin-top: 23px;
  max-width: 240px;
}
.wallet-type-connect-btn {
  background: transparent;
  color: #fff;
  border: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 50px;
  padding: 10px;
  width: 100%;
  display: block;
  text-align: center;
  &:hover {
    color: #3f5eab;
    background-color: #fff;
  }
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .wallet-item {
    padding: 18px;
    margin-bottom: 15px;
    height: auto;
  }
  .wallet-type-name {
    font-size: 20px;
  }
  .wallet-logo-box {
    float: left;
    width: 6rem;
    height: 6rem;
    background-color: #34495e;
    border-radius: 50%;
    text-align: center;
    margin-right: 17px;
  }
  .wallet-content-box {
    width: calc(100% - 7rem - 15px);
  }
  .img-logo-helper {
    width: 60px;
    line-height: 6rem;
    margin: 0 auto;
  }
  .img-logo-helper img {
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/WalletConnector/index.vue